unit Unit2;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Modules, XData.Web.Connection,
  WEBLib.REST, Data.DB, WEBLib.DB, XData.Web.JsonDataset, XData.Web.Dataset,
  XData.Web.Client, strutils, WEBLib.JSON;

type
  TDM2 = class(TDataModule)
    WebHttpRequest2: THttpRequest;
    WebHttpRequestLogbuch: THttpRequest;
    tableSYSDAT: TXDataWebDataSet;
    tableSYSDATDBKEY: TStringField;
    tableSYSDATNachname: TStringField;
    tableSYSDATVorname: TStringField;
    tableSYSDATNamenzeile2: TStringField;
    tableSYSDATNamenzeile3: TStringField;
    tableSYSDATStrasse: TStringField;
    tableSYSDATPostleitzahl: TStringField;
    tableSYSDATOrt: TStringField;
    tableSYSDATLaenderkuerzel: TStringField;
    tableSYSDATLand: TStringField;
    tableSYSDATTelefonnummer: TStringField;
    tableSYSDATTelefaxnummer: TStringField;
    tableSYSDATMobiltelefon: TStringField;
    tableSYSDATEmail: TStringField;
    tableSYSDATCadiaKundennummer: TStringField;
    tableSYSDATRundungIT: TBooleanField;
    tableSYSDATNachkommastellen: TIntegerField;
    tableSYSDATAbsenderzeile: TStringField;
    sourceSysdat: TDataSource;
    WClientAbsenderzeile: TXDataWebClient;
    XDataWebConnection1: TXDataWebConnection;
    tableSYSDATKuerzelAuftrag: TStringField;
    procedure XDataWebConnection1Request(Args: TXDataWebConnectionRequest);
    procedure WebHttpRequest2Response(Sender: TObject; AResponse: string);
    procedure XDataWebConnection1Connect(Sender: TObject);
    procedure tableSYSDATAfterOpen(DataSet: TDataSet);
  private
    { Private-Deklarationen }
  public
    { Public-Deklarationen }
  protected procedure LoadDFMValues; override; end;

var
  DM2: TDM2;

implementation
  uses unit1;
{%CLASSGROUP 'Vcl.Controls.TControl'}

{$R *.dfm}

procedure TDM2.tableSYSDATAfterOpen(DataSet: TDataSet);
  procedure OnResponse(Response:TXDataClientResponse);
  var
    mydownload:string;
  begin
    mydownload:=string(TJSObject(response.Result)['value']);
    TextAbsenderzeile:=leftstr(mydownload,70);
    WebHttpRequest2.URL:='https://cadia-software.net/cadiaautoserver/xdata/InformationService/cwlizenzonly?Kundennummer='+tableSYSDATCadiaKundennummer.AsString+'&AppKey='+CadiaAppKeyServerLizenz;
    WebHttpRequest2.Execute;
  end;
begin
  CadiaKundennummer:=dm2.tableSYSDATCadiaKundennummer.AsString;
  KuerzelAuftrag:=dm2.tableSYSDATKuerzelAuftrag.AsString;
  WClientAbsenderzeile.RawInvoke('IServerService.RTFTOTEXT',[tableSYSDATAbsenderzeile.AsString],@OnResponse);

end;

procedure TDM2.WebHttpRequest2Response(Sender: TObject; AResponse: string);
var
  JS:TJSON;
  JV:TJSONValue;
begin
  JS:=TJSON.Create;
  JV:=JS.Parse(AResponse);
  if assigned(JV) and (JV IS TJSONObject) then
  begin
    if TJSONObject(JV).GetJSONValue('value')='OK' then LizenzOK:=true;
    form1.labelonlinestatus.Caption:='Lizenz: '+TJSONObject(JV).GetJSONValue('value');
    form1.xdsCadiaServerSettings.Load;
  end;

end;

procedure TDM2.XDataWebConnection1Connect(Sender: TObject);
begin
  tablesysdat.Load;
end;

procedure TDM2.XDataWebConnection1Request(Args: TXDataWebConnectionRequest);
begin
  args.Request.Headers.SetValue('Authorization','Bearer ' + vToken);
end;

procedure TDM2.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebHttpRequest2 := THttpRequest.Create(Self);
  WebHttpRequestLogbuch := THttpRequest.Create(Self);
  tableSYSDAT := TXDataWebDataSet.Create(Self);
  tableSYSDATDBKEY := TStringField.Create(Self);
  tableSYSDATNachname := TStringField.Create(Self);
  tableSYSDATVorname := TStringField.Create(Self);
  tableSYSDATNamenzeile2 := TStringField.Create(Self);
  tableSYSDATNamenzeile3 := TStringField.Create(Self);
  tableSYSDATStrasse := TStringField.Create(Self);
  tableSYSDATPostleitzahl := TStringField.Create(Self);
  tableSYSDATOrt := TStringField.Create(Self);
  tableSYSDATLaenderkuerzel := TStringField.Create(Self);
  tableSYSDATLand := TStringField.Create(Self);
  tableSYSDATTelefonnummer := TStringField.Create(Self);
  tableSYSDATTelefaxnummer := TStringField.Create(Self);
  tableSYSDATMobiltelefon := TStringField.Create(Self);
  tableSYSDATEmail := TStringField.Create(Self);
  tableSYSDATCadiaKundennummer := TStringField.Create(Self);
  tableSYSDATRundungIT := TBooleanField.Create(Self);
  tableSYSDATNachkommastellen := TIntegerField.Create(Self);
  tableSYSDATAbsenderzeile := TStringField.Create(Self);
  tableSYSDATKuerzelAuftrag := TStringField.Create(Self);
  sourceSysdat := TDataSource.Create(Self);
  WClientAbsenderzeile := TXDataWebClient.Create(Self);
  XDataWebConnection1 := TXDataWebConnection.Create(Self);

  WebHttpRequest2.BeforeLoadDFMValues;
  WebHttpRequestLogbuch.BeforeLoadDFMValues;
  tableSYSDAT.BeforeLoadDFMValues;
  tableSYSDATDBKEY.BeforeLoadDFMValues;
  tableSYSDATNachname.BeforeLoadDFMValues;
  tableSYSDATVorname.BeforeLoadDFMValues;
  tableSYSDATNamenzeile2.BeforeLoadDFMValues;
  tableSYSDATNamenzeile3.BeforeLoadDFMValues;
  tableSYSDATStrasse.BeforeLoadDFMValues;
  tableSYSDATPostleitzahl.BeforeLoadDFMValues;
  tableSYSDATOrt.BeforeLoadDFMValues;
  tableSYSDATLaenderkuerzel.BeforeLoadDFMValues;
  tableSYSDATLand.BeforeLoadDFMValues;
  tableSYSDATTelefonnummer.BeforeLoadDFMValues;
  tableSYSDATTelefaxnummer.BeforeLoadDFMValues;
  tableSYSDATMobiltelefon.BeforeLoadDFMValues;
  tableSYSDATEmail.BeforeLoadDFMValues;
  tableSYSDATCadiaKundennummer.BeforeLoadDFMValues;
  tableSYSDATRundungIT.BeforeLoadDFMValues;
  tableSYSDATNachkommastellen.BeforeLoadDFMValues;
  tableSYSDATAbsenderzeile.BeforeLoadDFMValues;
  tableSYSDATKuerzelAuftrag.BeforeLoadDFMValues;
  sourceSysdat.BeforeLoadDFMValues;
  WClientAbsenderzeile.BeforeLoadDFMValues;
  XDataWebConnection1.BeforeLoadDFMValues;
  try
    Name := 'DM2';
    Height := 575;
    Width := 692;
    WebHttpRequest2.SetParentComponent(Self);
    WebHttpRequest2.Name := 'WebHttpRequest2';
    WebHttpRequest2.Headers.BeginUpdate;
    try
      WebHttpRequest2.Headers.Clear;
      WebHttpRequest2.Headers.Add('Cache-Control=no-cache, no-store, must-revalidate');
    finally
      WebHttpRequest2.Headers.EndUpdate;
    end;
    WebHttpRequest2.URL := 'https://langwald-edv.net/cadiaserver/xdata/$model';
    SetEvent(WebHttpRequest2, Self, 'OnResponse', 'WebHttpRequest2Response');
    WebHttpRequest2.Left := 64;
    WebHttpRequest2.Top := 104;
    WebHttpRequestLogbuch.SetParentComponent(Self);
    WebHttpRequestLogbuch.Name := 'WebHttpRequestLogbuch';
    WebHttpRequestLogbuch.Headers.BeginUpdate;
    try
      WebHttpRequestLogbuch.Headers.Clear;
      WebHttpRequestLogbuch.Headers.Add('Cache-Control=no-cache, no-store, must-revalidate');
    finally
      WebHttpRequestLogbuch.Headers.EndUpdate;
    end;
    WebHttpRequestLogbuch.Left := 208;
    WebHttpRequestLogbuch.Top := 104;
    tableSYSDAT.SetParentComponent(Self);
    tableSYSDAT.Name := 'tableSYSDAT';
    tableSYSDAT.AfterOpen := tableSYSDATAfterOpen;
    tableSYSDAT.EntitySetName := 'sysdat';
    tableSYSDAT.Connection := XDataWebConnection1;
    tableSYSDAT.Left := 176;
    tableSYSDAT.Top := 176;
    tableSYSDATDBKEY.SetParentComponent(tableSYSDAT);
    tableSYSDATDBKEY.Name := 'tableSYSDATDBKEY';
    tableSYSDATDBKEY.FieldName := 'DBKEY';
    tableSYSDATDBKEY.Size := 38;
    tableSYSDATNachname.SetParentComponent(tableSYSDAT);
    tableSYSDATNachname.Name := 'tableSYSDATNachname';
    tableSYSDATNachname.FieldName := 'Nachname';
    tableSYSDATNachname.Size := 40;
    tableSYSDATVorname.SetParentComponent(tableSYSDAT);
    tableSYSDATVorname.Name := 'tableSYSDATVorname';
    tableSYSDATVorname.FieldName := 'Vorname';
    tableSYSDATVorname.Size := 40;
    tableSYSDATNamenzeile2.SetParentComponent(tableSYSDAT);
    tableSYSDATNamenzeile2.Name := 'tableSYSDATNamenzeile2';
    tableSYSDATNamenzeile2.FieldName := 'Namenzeile2';
    tableSYSDATNamenzeile2.Size := 40;
    tableSYSDATNamenzeile3.SetParentComponent(tableSYSDAT);
    tableSYSDATNamenzeile3.Name := 'tableSYSDATNamenzeile3';
    tableSYSDATNamenzeile3.FieldName := 'Namenzeile3';
    tableSYSDATNamenzeile3.Size := 40;
    tableSYSDATStrasse.SetParentComponent(tableSYSDAT);
    tableSYSDATStrasse.Name := 'tableSYSDATStrasse';
    tableSYSDATStrasse.FieldName := 'Strasse';
    tableSYSDATStrasse.Size := 40;
    tableSYSDATPostleitzahl.SetParentComponent(tableSYSDAT);
    tableSYSDATPostleitzahl.Name := 'tableSYSDATPostleitzahl';
    tableSYSDATPostleitzahl.FieldName := 'Postleitzahl';
    tableSYSDATPostleitzahl.Size := 6;
    tableSYSDATOrt.SetParentComponent(tableSYSDAT);
    tableSYSDATOrt.Name := 'tableSYSDATOrt';
    tableSYSDATOrt.FieldName := 'Ort';
    tableSYSDATOrt.Size := 40;
    tableSYSDATLaenderkuerzel.SetParentComponent(tableSYSDAT);
    tableSYSDATLaenderkuerzel.Name := 'tableSYSDATLaenderkuerzel';
    tableSYSDATLaenderkuerzel.FieldName := 'Laenderkuerzel';
    tableSYSDATLaenderkuerzel.Size := 5;
    tableSYSDATLand.SetParentComponent(tableSYSDAT);
    tableSYSDATLand.Name := 'tableSYSDATLand';
    tableSYSDATLand.FieldName := 'Land';
    tableSYSDATLand.Size := 40;
    tableSYSDATTelefonnummer.SetParentComponent(tableSYSDAT);
    tableSYSDATTelefonnummer.Name := 'tableSYSDATTelefonnummer';
    tableSYSDATTelefonnummer.FieldName := 'Telefonnummer';
    tableSYSDATTelefonnummer.Size := 25;
    tableSYSDATTelefaxnummer.SetParentComponent(tableSYSDAT);
    tableSYSDATTelefaxnummer.Name := 'tableSYSDATTelefaxnummer';
    tableSYSDATTelefaxnummer.FieldName := 'Telefaxnummer';
    tableSYSDATTelefaxnummer.Size := 25;
    tableSYSDATMobiltelefon.SetParentComponent(tableSYSDAT);
    tableSYSDATMobiltelefon.Name := 'tableSYSDATMobiltelefon';
    tableSYSDATMobiltelefon.FieldName := 'Mobiltelefon';
    tableSYSDATMobiltelefon.Size := 25;
    tableSYSDATEmail.SetParentComponent(tableSYSDAT);
    tableSYSDATEmail.Name := 'tableSYSDATEmail';
    tableSYSDATEmail.FieldName := 'Email';
    tableSYSDATEmail.Size := 70;
    tableSYSDATCadiaKundennummer.SetParentComponent(tableSYSDAT);
    tableSYSDATCadiaKundennummer.Name := 'tableSYSDATCadiaKundennummer';
    tableSYSDATCadiaKundennummer.FieldName := 'CadiaKundennummer';
    tableSYSDATCadiaKundennummer.Size := 13;
    tableSYSDATRundungIT.SetParentComponent(tableSYSDAT);
    tableSYSDATRundungIT.Name := 'tableSYSDATRundungIT';
    tableSYSDATRundungIT.FieldName := 'RundungIT';
    tableSYSDATNachkommastellen.SetParentComponent(tableSYSDAT);
    tableSYSDATNachkommastellen.Name := 'tableSYSDATNachkommastellen';
    tableSYSDATNachkommastellen.FieldName := 'Nachkommastellen';
    tableSYSDATAbsenderzeile.SetParentComponent(tableSYSDAT);
    tableSYSDATAbsenderzeile.Name := 'tableSYSDATAbsenderzeile';
    tableSYSDATAbsenderzeile.FieldName := 'Absenderzeile';
    tableSYSDATAbsenderzeile.Size := 255;
    tableSYSDATKuerzelAuftrag.SetParentComponent(tableSYSDAT);
    tableSYSDATKuerzelAuftrag.Name := 'tableSYSDATKuerzelAuftrag';
    tableSYSDATKuerzelAuftrag.FieldName := 'KuerzelAuftrag';
    tableSYSDATKuerzelAuftrag.Size := 1;
    sourceSysdat.SetParentComponent(Self);
    sourceSysdat.Name := 'sourceSysdat';
    sourceSysdat.DataSet := tableSYSDAT;
    sourceSysdat.Left := 64;
    sourceSysdat.Top := 176;
    WClientAbsenderzeile.SetParentComponent(Self);
    WClientAbsenderzeile.Name := 'WClientAbsenderzeile';
    WClientAbsenderzeile.Connection := XDataWebConnection1;
    WClientAbsenderzeile.Left := 64;
    WClientAbsenderzeile.Top := 248;
    XDataWebConnection1.SetParentComponent(Self);
    XDataWebConnection1.Name := 'XDataWebConnection1';
    XDataWebConnection1.URL := 'https://langwald-edv.net:443/mandant01/cadiaserver/xdata';
    SetEvent(XDataWebConnection1, Self, 'OnConnect', 'XDataWebConnection1Connect');
    SetEvent(XDataWebConnection1, Self, 'OnRequest', 'XDataWebConnection1Request');
    XDataWebConnection1.Left := 64;
    XDataWebConnection1.Top := 32;
  finally
    WebHttpRequest2.AfterLoadDFMValues;
    WebHttpRequestLogbuch.AfterLoadDFMValues;
    tableSYSDAT.AfterLoadDFMValues;
    tableSYSDATDBKEY.AfterLoadDFMValues;
    tableSYSDATNachname.AfterLoadDFMValues;
    tableSYSDATVorname.AfterLoadDFMValues;
    tableSYSDATNamenzeile2.AfterLoadDFMValues;
    tableSYSDATNamenzeile3.AfterLoadDFMValues;
    tableSYSDATStrasse.AfterLoadDFMValues;
    tableSYSDATPostleitzahl.AfterLoadDFMValues;
    tableSYSDATOrt.AfterLoadDFMValues;
    tableSYSDATLaenderkuerzel.AfterLoadDFMValues;
    tableSYSDATLand.AfterLoadDFMValues;
    tableSYSDATTelefonnummer.AfterLoadDFMValues;
    tableSYSDATTelefaxnummer.AfterLoadDFMValues;
    tableSYSDATMobiltelefon.AfterLoadDFMValues;
    tableSYSDATEmail.AfterLoadDFMValues;
    tableSYSDATCadiaKundennummer.AfterLoadDFMValues;
    tableSYSDATRundungIT.AfterLoadDFMValues;
    tableSYSDATNachkommastellen.AfterLoadDFMValues;
    tableSYSDATAbsenderzeile.AfterLoadDFMValues;
    tableSYSDATKuerzelAuftrag.AfterLoadDFMValues;
    sourceSysdat.AfterLoadDFMValues;
    WClientAbsenderzeile.AfterLoadDFMValues;
    XDataWebConnection1.AfterLoadDFMValues;
  end;
end;

end.
